<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModal"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      New Admin
    </button>
    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Email</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Options</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-16 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.email }}
              </span>
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.name }}
              </span>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button
                  class=""
                  type="button"
                  @click="showModalDestroy(sos.id)"
                >
                  <fas icon="trash-alt" class="text-red-600 text-xl" />
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="rows.length === 0">
            <td colspan="4" class="text-center p-2">No Data</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modal -->
    <div
      v-if="modalCreate"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 500px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">{{ title }}</div>
            <div class="">
              <button @click.self="closeModal" class="font-3xl font-bold p-6">
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="create.name"
                  @keyup="nameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.name_msg }}
                </div>
                <input
                  v-model="create.email"
                  @keyup="emailChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.email
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Email"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.email_msg }}
                </div>
                <input
                  v-model="create.password"
                  @keyup="passwordChange"
                  type="password"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.password
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Password"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.password_msg }}
                </div>
                <input
                  v-model="create.confirm_password"
                  @keyup="confirmPasswordChange"
                  type="password"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.confirm_password
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Confirm Password"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.confirm_password_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModal"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="saveNewAdmin"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModal"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Warning !</div>
            <div class="">
              <button
                @click.self="closeModalDestroy"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            Are You Sure To Continue Delete This User
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="deleteUser"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <SuccessNotif />
    <Warning />
  </main>
</template>

<script>
import API from "../../api";
import SuccessNotif from "../../components/SuccessNotif.vue";
import Warning from "../../components/Warning.vue";
export default {
  name: "Table",
  components: { SuccessNotif, Warning },
  data() {
    return {
      modalDestroy: false,
      modalCreate: false,
      errors: {
        name: false,
        email: false,
        password: false,
        confirm_password: false,
        name_msg: "",
        email_msg: "",
        password_msg: "",
        confirm_password_msg: "",
      },
      create: {
        name: "",
        email: "",
        password: "",
        confirm_password: "",
      },
      title: "",
      rows: [],
      id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    nameChange: function(e) {
      this.create.name = e.target.value;
      this.errors.name = false;
      this.errors.name_msg = "";
    },
    emailChange: function(e) {
      this.create.email = e.target.value;
      this.errors.email = false;
      this.errors.email_msg = "";
    },
    passwordChange: function(e) {
      this.create.password = e.target.value;
      this.errors.password = false;
      this.errors.password_msg = "";
    },
    confirmPasswordChange: function(e) {
      this.create.confirm_password = e.target.value;
      this.errors.confirm_password = false;
      this.errors.confirm_password_msg = "";
    },
    showModalDestroy: function(id) {
      this.id = id;
      this.modalDestroy = true;
    },
    closeModalDestroy: function() {
      this.id = null;
      this.modalDestroy = false;
    },
    showModal: function() {
      this.create = {
        name: "",
        email: "",
        password: "",
        confirm_password: "",
      };
      this.title = "Create New";
      this.modalCreate = true;
    },
    closeModal: function() {
      this.modalCreate = false;
    },
    findUsers: async function() {
      try {
        let res = await fetch(`${API}v1/admin/users`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    saveNewAdmin: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/users/store`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            name: this.create.name,
            email: this.create.email,
            password: this.create.password,
            confirm_password: this.create.confirm_password,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "name") {
                this.errors.name = true;
                this.errors.name_msg = item.message;
              }
              if (item.key === "email") {
                this.errors.email = true;
                this.errors.email_msg = item.message;
              }
              if (item.key === "password") {
                this.errors.password = true;
                this.errors.password_msg = item.message;
              }
              if (item.key === "confirm_password") {
                this.errors.confirm_password = true;
                this.errors.confirm_password_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this._error("internal server error");
          return;
        }
        this.saveButton = "Save";
        this.modalCreate = false;
        this.findUsers();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    deleteUser: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/users/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.findUsers();
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },

  created: function() {
    if (!this.$store.state.isAdmin) {
      this.$router.push("/");
    }
    this.findUsers();
  },
  beforeMount: function() {},
};
</script>
